import styled from '@emotion/styled';
import { ITheme } from '../../../../ui';
import themed from '../../../../ui/themer/themed';

export const StyledBookingDetailsTable = styled.table`
	width: 100%;
	margin-bottom: 24px;
`;

export const StyledBookingDetailsTableBody = styled.tbody``;

export const StyledBookingDetailsRow = styled.tr<{}, ITheme>`
	border-bottom: 1px solid ${themed(({ color }) => color.border.default)};
	padding: 0;

	&:first-of-type {
		border-top: 1px solid ${themed(({ color }) => color.border.default)};
	}
`;

interface IStyledBookingDetailsCellProps {
	bold?: boolean;
	light?: boolean;
}

export const StyledBookingDetailsCell = styled.td<
	IStyledBookingDetailsCellProps,
	ITheme
>`
	padding: 16px 8px 16px 0;

	font-weight: ${({ bold }) => (bold ? 'bold' : '')};
	color: ${themed(({ color }, { light }) => (light ? color.text.light : ''))};
`;
